import { CommApiInstance } from "Utils/CommApiInstance";




const MembMktgAgreChngApi = async (
    emlNtfyRecvYn: string | null,
    smsNtfyRecvYn: string
) => {
    return await CommApiInstance.post("memb/mktg/chng",{
        apiBody:{
            emlNtfyRecvYn:emlNtfyRecvYn,
            smsNtfyRecvYn:smsNtfyRecvYn
        },
    })
    .then((Resp) => Resp.data);
}
export default MembMktgAgreChngApi;